import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { GolfRegistration } from "./hooks/useGolfData";

interface GolfTableProps {
  registrations: GolfRegistration[];
}

export const GolfTable = ({ registrations }: GolfTableProps) => {
  return (
    <div className="rounded-md border overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nom</TableHead>
            <TableHead>Prénom</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Téléphone</TableHead>
            <TableHead>Index</TableHead>
            <TableHead>Statut paiement</TableHead>
            <TableHead>Date de création</TableHead>
            <TableHead>Coéquipier</TableHead>
            <TableHead className="text-right">Montant</TableHead>
            <TableHead className="text-right">Don additionnel</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {registrations.map((r) => (
            <TableRow key={r.id}>
              <TableCell>{r.last_name}</TableCell>
              <TableCell>{r.first_name}</TableCell>
              <TableCell>{r.email}</TableCell>
              <TableCell>{r.phone || "-"}</TableCell>
              <TableCell>{r.golf_index}</TableCell>
              <TableCell>{r.payment_status}</TableCell>
              <TableCell>
                {format(new Date(r.created_at), "dd/MM/yyyy", { locale: fr })}
              </TableCell>
              <TableCell>{r.teammate || "-"}</TableCell>
              <TableCell className="text-right">
                {r.amount ? `${r.amount} €` : "-"}
              </TableCell>
              <TableCell className="text-right">
                {r.additional_donation ? `${r.additional_donation} €` : "-"}
              </TableCell>
            </TableRow>
          ))}
          {registrations.length === 0 && (
            <TableRow>
              <TableCell colSpan={10} className="text-center text-muted-foreground py-6">
                Aucune inscription
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
